export const setupContentUrl = (uri) => {
  return setupUrl(uri, process.env.REACT_APP_CONTENT_BASE_URL);
};

export const setupCurrentOriginUrl = (uri) => {
  return setupUrl(uri, window.location.origin);
};

const setupUrl = (uri, domain) => {
  if (typeof uri != 'string' || uri.trim().length === 0) {
    return undefined;
  }
  const trimmedUri = uri.trim();
  if (hasDomain(trimmedUri) || domain == null) {
    return trimmedUri;
  }
  return trimmedUri.startsWith('/') ? domain.concat(trimmedUri) : domain.concat('/', trimmedUri);
};

export const hasDomain = (uri) => {
  if (typeof uri != 'string') {
    return false;
  }
  try {
    const url = new URL(uri);
    return Boolean(url.hostname);
  } catch {
    return false;
  }
};
